import { Injectable, effect, inject, signal } from '@angular/core';
import { ApiService } from '../api/api.service';
import { LanguageService } from '../language-service/language.service';
import { WeatherDto } from './weather.interface';


@Injectable({
  providedIn: 'root'
})
export class WeatherService {
  private apiService = inject(ApiService);
  private languageService = inject(LanguageService);

  public weatherData = signal<WeatherDto>(null);
  private lastCity: string;

  constructor() {
    effect(() => {
      const lang = this.languageService.selected();
      if (lang !== undefined && this.lastCity) {
        this.getWeatherData(this.lastCity);
      }
    });
  }

  getWeatherData(city: string): void {
    this.lastCity = city;
    this.apiService.getWeather(city, this.languageService.selected()).subscribe(res => {
      this.weatherData.set(res);
    });
  }

} 
